import { Link } from 'react-router-dom'
import { Icon } from '@winnin/winnin_ui.components.icon'
import { Title } from '@winnin/winnin_ui.components.title'

const CreatorLink = ({ noLink, isIncompleteCreator, title, id, provider, groupId, onCreatorClickCallback }) => {
  if (noLink) {
    return (
      <Title
        tag="h6"
        weight="light"
        onClick={e => {
          e.stopPropagation()
        }}
        className="CreatorCardOnHover-truncate"
      >
        {title}
      </Title>
    )
  }
  if (isIncompleteCreator) {
    return (
      <Title tag="h6" weight="light" variation="secondary">
        <span className="creatorIncompleteTitle">@{title}</span>
        <Icon icon="exclamationMark" width={24} height={24} className="CreatorIncomplete-title-icon" />
      </Title>
    )
  }

  return (
    <Link
      target={'_self'}
      to={`/group/${groupId}/${id}/${provider}`}
      onClick={e => {
        e.stopPropagation()
        onCreatorClickCallback?.()
      }}
      className="CreatorCardOnHover-truncate"
    >
      {title}
    </Link>
  )
}

export default CreatorLink
